'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var getAllValues = exports.getAllValues = function getAllValues(allForms) {
  var values = Object.keys(allForms).reduce(function (acc, form) {
    if (allForms[form].values !== undefined) {
      return Object.assign({}, acc, allForms[form].values);
    }
    return acc;
  }, {});
  return values;
};
var getAllValuesByForm = exports.getAllValuesByForm = function getAllValuesByForm(allForms) {
  var values = Object.keys(allForms).reduce(function (acc, form) {
    if (allForms[form].values !== undefined) {
      var newAcc = acc;
      newAcc[form] = allForms[form].values;
      return newAcc;
    }
    return acc;
  }, {});
  return values;
};
var getRequiredFieldsWithError = exports.getRequiredFieldsWithError = function getRequiredFieldsWithError(allForms) {
  var syncErrors = Object.keys(allForms).reduce(function (acc, form) {
    if (allForms[form].syncErrors !== undefined) {
      return Object.assign({}, acc, allForms[form].syncErrors);
    }
    return acc;
  }, {});
  return syncErrors;
};
var getNonRequiredFieldsWithWarning = exports.getNonRequiredFieldsWithWarning = function getNonRequiredFieldsWithWarning(allForms) {
  var syncWarnings = Object.keys(allForms).reduce(function (acc, form) {
    if (allForms[form].syncWarnings !== undefined) {
      return Object.assign({}, acc, allForms[form].syncWarnings);
    }
    return acc;
  }, {});
  return syncWarnings;
};
var getNonRequiredFieldsWithWarningByForm = exports.getNonRequiredFieldsWithWarningByForm = function getNonRequiredFieldsWithWarningByForm(allForms) {
  var syncWarnings = Object.keys(allForms).reduce(function (acc, form) {
    if (allForms[form].syncWarnings !== undefined) {
      var newAcc = acc;
      newAcc[form] = allForms[form].syncWarnings;
      return newAcc;
    }
    return acc;
  }, {});
  return syncWarnings;
};
var getFieldsLabel = exports.getFieldsLabel = function getFieldsLabel(keysSource, usedFields) {
  var labels = [];
  if (Array.isArray(keysSource)) {
    if (keysSource.length > 0) {
      labels = keysSource.map(function (key) {
        return usedFields[key].label;
      });
    }
  } else if ((typeof keysSource === 'undefined' ? 'undefined' : _typeof(keysSource)) === 'object') {
    var keys = Object.keys(keysSource);
    if (keys.length > 0) {
      labels = Object.keys(keysSource).map(function (key) {
        return usedFields[key].label;
      });
    }
  }
  return labels;
};